import { browserHistory } from 'react-router';
import cloneDeep from 'lodash/cloneDeep';
import { ticketLinkTypes } from '../../../../common/constants/ticketLinkTypes';
import { ticketProcessTypes } from '../../../../common/constants/ticketProcessTypes';
import {
  FETCH_SPECIFIC_EVENT_DATA_SUCCESS,
  FETCH_SPECIFIC_EVENT_DATA_BEGIN,
} from '../../routes/CreateTemplate/modules/importEvent';
import {
  FETCH_TEMPLATE_EDIT_DATA_SUCCESS,
  FETCH_TEMPLATE_EDIT_DATA_BEGIN,
  FETCH_TEMPLATE_BASE_EVENT_SUCCESS,
  FETCH_TEMPLATE_BASE_EVENT_BEGIN,
  DIRECT_TO_EDIT_TEMPLATE,
  GET_REMAINING_OFFERS_BEGIN,
  GET_REMAINING_OFFERS_SUCCESS,
  GET_REMAINING_OFFERS_FAILURE,
  fetchTemplateBaseEventBegin,
  fetchTemplateBaseEventSuccess,
  fetchTemplateEditDataSuccess,
  directToEditTemplate,
  loadTemplates,
  fetchTemplateEditDataFailure,
  fetchTemplateEditDataBegin,
} from '../../modules/templateChron';
import { UPDATE_NOTIFICATION } from '../../../../store/app';
import { receiveOfferPromotion } from '../../../../common/lib/OfferPromotion/offerPromotion';
import camelcaseKeysDeep from 'camelcase-keys-deep';
import {
  saveTemplate,
  updateTemplate,
  getEventCategories,
  getSeasonCategories,
  deleteTemplate,
  getPromoGroups,
  getPromoTemplates,
  patchDeactivateTemplate,
  patchActivateTemplate,
  getEvent,
  getTemplate,
  getLDFlagValue,
} from '../../../../api/ApiManager';
import { selectContextId } from './templateForm.selectors';
import {
  formatEventsCategory,
  formatSeasonsCategory,
  indexOfObjects,
  filterOnlyNews,
  mergeTwoObject,
  mergeZoneOffers,
} from '../helpers/index';

import { RemainingOffersErrors } from '../../../../common/constants/errorMessages';
import { loadTemplateBegin } from '../../../EventDetails/modules/eventDetails';
import {
  SET_LD_FLAG,
  setLDFlag,
} from '../../../EventDetails/routes/admissions/modules/admissions';

// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_EVENT_DATA_FOR_TEMPLATE_FORM =
  'FETCH_EVENT_DATA_FOR_TEMPLATE_FORM';
export const SELECTED_EVENT_TYPE_FROM_DROPDOWN =
  'SELECTED_EVENT_TYPE_FROM_DROPDOWN';
export const SELECTED_SEASON_TYPE_FROM_DROPDOWN =
  'SELECTED_SEASON_TYPE_FROM_DROPDOWN';
export const REMOVE_SELECTED_OFFER = 'REMOVE_SELECTED_OFFER';
export const CANCEL_TEMPLATE_CREATION = 'CANCEL_EVENT_TEMPLATE_CREATION';

export const CHANGE_OFFER_PUBLIC_MODE = 'CHANGE_OFFER_PUBLIC_MODE';

export const SUBMIT_CREATE_TEMPLATE_BEGIN = 'SUBMIT_CREATE_TEMPLATE_BEGIN';
export const SUBMIT_CREATE_TEMPLATE_SUCCESS = 'SUBMIT_CREATE_TEMPLATE_SUCCESS';
export const SUBMIT_CREATE_TEMPLATE_FAILURE = 'SUBMIT_CREATE_TEMPLATE_FAILURE';

export const SUBMIT_EDIT_TEMPLATE_BEGIN = 'SUBMIT_EDIT_TEMPLATE_BEGIN';
export const SUBMIT_EDIT_TEMPLATE_SUCCESS = 'SUBMIT_EDIT_TEMPLATE_SUCCESS';
export const SUBMIT_EDIT_TEMPLATE_FAILURE = 'SUBMIT_EDIT_TEMPLATE_FAILURE';
export const HANDLE_TEMPLATE_NAME_INPUT = 'HANDLE_TEMPLATE_NAME_INPUT';
export const REDIRECT_TO_TEMPLATE_MANAGEMENT =
  'REDIRECT_TO_TEMPLATE_MANAGEMENT';

export const LOAD_TEMPLATE_BEGIN = 'LOAD_TEMPLATE_BEGIN';
export const LOAD_TEMPLATE_SUCCESS = 'LOAD_TEMPLATE_SUCCESS';

export const DELETE_TEMPLATE_BEGIN = 'DELETE_TEMPLATE_BEGIN';
export const DELETE_TEMPLATE_FAILURE = 'DELETE_TEMPLATE_FAILURE';
export const DELETE_TEMPLATE_SUCCESS = 'DELETE_TEMPLATE_SUCCESS';

export const GET_EVENT_CATEGORIES_BEGIN = 'GET_EVENT_CATEGORIES_BEGIN';
export const GET_EVENT_CATEGORIES_FAILURE = 'GET_EVENT_CATEGORIES_FAILURE';
export const GET_EVENT_CATEGORIES_SUCCESS = 'GET_EVENT_CATEGORIES_SUCCESS';

export const GET_SEASON_CATEGORIES_BEGIN = 'GET_SEASON_CATEGORIES_BEGIN';
export const GET_SEASON_CATEGORIES_FAILURE = 'GET_SEASON_CATEGORIES_FAILURE';
export const GET_SEASON_CATEGORIES_SUCCESS = 'GET_SEASON_CATEGORIES_SUCCESS';

export const GET_PROMO_GROUPS_BEGIN = 'GET_PROMO_GROUPS_BEGIN';
export const GET_PROMO_GROUPS_SUCCESS = 'GET_PROMO_GROUPS_SUCCESS';
export const GET_PROMO_GROUPS_FAILURE = 'GET_PROMO_GROUPS_FAILURE';
export const GET_PROMO_TEMPLATES_BEGIN = 'GET_PROMO_TEMPLATES_BEGIN';
export const GET_PROMO_TEMPLATES_FAILURE = 'GET_PROMO_TEMPLATES_FAILURE';
export const GET_PROMO_TEMPLATES_SUCCESS = 'GET_PROMO_TEMPLATES_SUCCESS';
export const DIRECT_TO_EDIT_TEMPLATE_OFFER = 'DIRECT_TO_EDIT_TEMPLATE_OFFER';
export const REMOVED_SELECTED_ZONE = 'REMOVED_SELECTED_ZONE';
export const DIRECT_TO_CREATE_TEMPLATE_EDIT_OFFER =
  'DIRECT_TO_CREATE_TEMPLATE_EDIT_OFFER';
export const DIRECT_TO_CREATE_TEMPLATE_FINALIZE =
  'DIRECT_TO_CREATE_TEMPLATE_FINALIZE';
export const UPDATE_TEMPLATE_OFFER_CMS = 'UPDATE_TEMPLATE_OFFER_CMS';
export const DEACTIVATE_TEMPLATE_BEGIN = 'DEACTIVATE_TEMPLATE_BEGIN';
export const ACTIVATE_TEMPLATE_BEGIN = 'ACTIVATE_TEMPLATE_BEGIN';

// ------------------------------------
// Actions
// ------------------------------------

///////////////
///// Routing
//////////////
export const directToCreateTemplateFinalize = () => {
  browserHistory.push('/templates/create/finalize/');
  return { type: DIRECT_TO_CREATE_TEMPLATE_FINALIZE };
};

export const directToEditTemplateOffer = (templateId, offerId) => {
  browserHistory.push(`/templates/${templateId}/edit/${offerId}`);
  return { type: DIRECT_TO_EDIT_TEMPLATE_OFFER };
};

export const directToCreateTemplateEditOffer = (offerId) => {
  browserHistory.push(`/templates/create/finalize/${offerId}`);
  return { type: DIRECT_TO_CREATE_TEMPLATE_EDIT_OFFER };
};

export const redirectToTemplateManagement = () => {
  browserHistory.push('/templates');
  return { type: REDIRECT_TO_TEMPLATE_MANAGEMENT };
};

export const cancelTemplateButtonClick = () => {
  return (dispatch) => {
    dispatch(cancelTemplateCreation());
    dispatch(redirectToTemplateManagement());
  };
};

///////////////
///// User Input
///////////////
export const updateTemplateOfferCms = (offerId, zoneId, data) => {
  return { type: UPDATE_TEMPLATE_OFFER_CMS, offerId, zoneId, data };
};

export const selectedEventTypeFromDropDown = (eventCategory) => {
  return { type: SELECTED_EVENT_TYPE_FROM_DROPDOWN, eventCategory };
};

export const selectedSeasonTypeFromDropDown = (seasonCategory) => {
  return { type: SELECTED_SEASON_TYPE_FROM_DROPDOWN, seasonCategory };
};

export const removeSelectedOffer = (offer) => {
  return { type: REMOVE_SELECTED_OFFER, offer };
};

export const changeOfferPublishMode = (offer) => {
  return { type: CHANGE_OFFER_PUBLIC_MODE, offer };
};

export const removeSelectedZone = (zone) => {
  return { type: REMOVED_SELECTED_ZONE, zone };
};

export const cancelTemplateCreation = () => {
  return { type: CANCEL_TEMPLATE_CREATION };
};

export const handleTemplateNameInput = (text) => {
  return { type: HANDLE_TEMPLATE_NAME_INPUT, text };
};

export const updateNotifications = (message, status) => {
  return { type: UPDATE_NOTIFICATION, message, status };
};

/////////////////
///// API Actions
/////////////////
export const getPromoTemplatesBegin = () => {
  return { type: GET_PROMO_TEMPLATES_BEGIN };
};

export const getPromoTemplatesFailure = (err) => {
  return { type: GET_PROMO_TEMPLATES_FAILURE, err };
};

export const getPromoTemplatesSuccess = (promoTemplates) => {
  return { type: GET_PROMO_TEMPLATES_SUCCESS, promoTemplates };
};

export const getPromoGroupsBegin = () => {
  return { type: GET_PROMO_GROUPS_BEGIN };
};

export const getPromoGroupsFailure = (err) => {
  return { type: GET_PROMO_GROUPS_FAILURE, err };
};

export const getPromoGroupsSuccess = (promoGroups) => {
  return { type: GET_PROMO_GROUPS_SUCCESS, promoGroups };
};

export const fetchEventCategoriesBegin = () => {
  return { type: GET_EVENT_CATEGORIES_BEGIN };
};

export const fetchEventCategoriesFailure = (failureMessage) => {
  return { type: GET_EVENT_CATEGORIES_FAILURE, failureMessage };
};

export const fetchEventCategoriesSuccess = (eventCategories) => {
  return { type: GET_EVENT_CATEGORIES_SUCCESS, eventCategories };
};

export const fetchSeasonCategoriesBegin = () => {
  return { type: GET_SEASON_CATEGORIES_BEGIN };
};

export const fetchSeasonCategoriesFailure = (failureMessage) => {
  return { type: GET_SEASON_CATEGORIES_FAILURE, failureMessage };
};

export const fetchSeasonCategoriesSuccess = (seasonCategories) => {
  return { type: GET_SEASON_CATEGORIES_SUCCESS, seasonCategories };
};

export const deleteTemplateBegin = () => {
  return { type: DELETE_TEMPLATE_BEGIN };
};

export const deleteTemplateFailure = (failureMessage) => {
  return { type: DELETE_TEMPLATE_FAILURE, failureMessage };
};

export const deleteTemplateSuccess = (successMessage) => {
  return { type: DELETE_TEMPLATE_SUCCESS, successMessage };
};

export const submitCreateTemplateBegin = () => {
  return { type: SUBMIT_CREATE_TEMPLATE_BEGIN };
};

export const submitCreateTemplateSuccess = (successMessage, templateId) => {
  return { type: SUBMIT_CREATE_TEMPLATE_SUCCESS, successMessage, templateId };
};

export const submitCreateTemplateFailure = (failureMessage) => {
  return { type: SUBMIT_CREATE_TEMPLATE_FAILURE, failureMessage };
};

export const submitEditTemplateBegin = () => {
  return { type: SUBMIT_EDIT_TEMPLATE_BEGIN };
};

export const submitEditTemplateSuccess = (successMessage, templateId) => {
  return { type: SUBMIT_EDIT_TEMPLATE_SUCCESS, successMessage, templateId };
};

export const submitEditTemplateFailure = (failureMessage) => {
  return { type: SUBMIT_EDIT_TEMPLATE_FAILURE, failureMessage };
};

export const deactivateTemplateBegin = () => {
  return { type: DEACTIVATE_TEMPLATE_BEGIN };
};

export const activateTemplateBegin = () => {
  return { type: ACTIVATE_TEMPLATE_BEGIN };
};

////////////////////
//Async Actions
/////////////////////

export const showNotification = (message, status) => {
  return (dispatch) => {
    dispatch(updateNotifications(message, status));
    setTimeout(() => {
      dispatch({ type: 'HIDE_NOTIFICATION' });
    }, 8000);
  };
};

export const fetchPromoGroups = () => {
  return (dispatch) => {
    dispatch(getPromoGroupsBegin());
    getPromoGroups()
      .then((response) => {
        const noError = response.data.hasOwnProperty('Promotiongroups');
        if (noError) {
          const promoGroups = response.data.Promotiongroups;
          dispatch(getPromoGroupsSuccess(promoGroups));
        } else {
          dispatch(getPromoGroupsFailure('Failed to fetch promo groups.'));
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(getPromoGroupsFailure(err.message));
      });
  };
};

export const fetchPromoTemplates = (promoGroupId) => {
  return (dispatch) => {
    dispatch(getPromoTemplatesBegin());
    getPromoTemplates(promoGroupId)
      .then((response) => {
        const promoTemplates = camelcaseKeysDeep(
          response.data.PromotionTemplates
        );
        dispatch(getPromoTemplatesSuccess(promoTemplates));
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(getPromoTemplatesFailure(err));
      });
  };
};

export const loadAutoPubLDFlag = (flag) => async (dispatch, getState) => {
  try {
    const contextId = getState().app.contextId;
    const {
      data: { IsEnabled },
    } = await getLDFlagValue(contextId, flag);

    dispatch(setLDFlag(flag, IsEnabled, true));
  } catch (e) {
    dispatch(setLDFlag(flag, false, false));
  }
};

export const submitCreateTemplate = (templateInfo) => {
  // this may not need eventId
  return (dispatch, getState) => {
    const context = getState().app.contextId.toString();
    const {
      templateName,
      categoryIds,
      zoneIds,
      templateZones,
      eventId,
    } = templateInfo;
    dispatch(submitCreateTemplateBegin());
    saveTemplate(
      context,
      templateName,
      categoryIds,
      eventId,
      zoneIds,
      templateZones
    )
      .then((response) => {
        const success = response.data.ResponseStatus.Message === 'Success';
        if (success) {
          const message = response.data.ResponseStatus.Message;
          const templateId = response.data.TemplateId;
          dispatch(submitCreateTemplateSuccess(message, templateId));
          dispatch(redirectToTemplateManagement());
          dispatch(showNotification('Template published.', 'success'));
        } else {
          dispatch(showNotification('Failed to publish template.', 'error'));
          dispatch(submitCreateTemplateFailure('Failed to publish template.'));
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(submitCreateTemplateFailure(err));
      });
  };
};

export const submitEditTemplate = (templateInfo) => {
  return (dispatch, getState) => {
    const context = getState().app.contextId.toString();
    const {
      templateName,
      categoryIds,
      zoneIds,
      templateId,
      templateZones,
      eventId,
    } = templateInfo;
    dispatch(submitEditTemplateBegin());

    updateTemplate(
      context,
      templateName,
      categoryIds,
      eventId,
      templateId,
      zoneIds,
      templateZones
    )
      .then((response) => {
        const success = response.data.ResponseStatus.Message === 'Success';
        if (success) {
          const message = response.data.ResponseStatus.Message;
          const templateId = response.data.TemplateId;

          dispatch(showNotification('Template saved.', 'success'));
          dispatch(submitEditTemplateSuccess(message, templateId));
          dispatch(redirectToTemplateManagement());
        } else {
          dispatch(showNotification('Failed to save template.', 'error'));
          dispatch(submitEditTemplateFailure('Failed to save template.'));
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(submitEditTemplateFailure(err));
      });
  };
};

export const fetchEventCategories = () => {
  return (dispatch, getState) => {
    dispatch(fetchEventCategoriesBegin());
    const contextId = getState().app.contextId.toString();
    getEventCategories(contextId)
      .then((response) => {
        if (response.status === 200) {
          const eventCategories = camelcaseKeysDeep(
            response.data.EventCategories
          );
          dispatch(fetchEventCategoriesSuccess(eventCategories));
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(
          fetchEventCategoriesFailure('Failed to fetch Event Categories.')
        );
      });
  };
};

export const fetchSeasonCategories = () => {
  return (dispatch, getState) => {
    dispatch(fetchSeasonCategoriesBegin());
    const contextId = getState().app.contextId.toString();
    getSeasonCategories(contextId)
      .then((response) => {
        if (response.status === 200) {
          const seasonCategories = camelcaseKeysDeep(
            response.data.SeasonCategories
          );
          dispatch(fetchSeasonCategoriesSuccess(seasonCategories));
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(
          fetchSeasonCategoriesFailure('Failed to fetch Season Categories.')
        );
      });
  };
};

export const destroyTemplate = (templateId) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId.toString();
    dispatch(deleteTemplateBegin());
    deleteTemplate(contextId, templateId)
      .then((response) => {
        if (response.data.ResponseStatus.Message === 'Success') {
          dispatch(showNotification('Template deleted.', 'success'));
        } else {
          dispatch(showNotification('Unable to delete template.', 'error'));
          dispatch(deleteTemplateFailure('Unable to delete template.'));
        }
        dispatch(redirectToTemplateManagement());
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
        dispatch(deleteTemplateFailure(err));
      });
  };
};

export const deactivateTemplate = (templateId) => {
  return (dispatch, getState) => {
    const contextId = selectContextId(getState()).toString();
    dispatch(deactivateTemplateBegin());
    patchDeactivateTemplate(contextId, templateId)
      .then((resp) => {
        const success =
          resp &&
          resp.data &&
          resp.data.ResponseStatus &&
          resp.data.ResponseStatus.Message === 'Success';
        if (success) {
          const templateId = resp.data.TemplateId;
          dispatch(fetchTemplateEditDataBegin());
          return getTemplate(contextId, templateId)
            .then((response) => {
              const success =
                response.data.ResponseStatus.Message === 'Success';
              if (success) {
                const found = cloneDeep(response.data.Templates[0]);
                const templateData = camelcaseKeysDeep(found);
                dispatch(fetchTemplateEditDataSuccess(templateData));
              } else {
                dispatch(fetchTemplateEditDataFailure());
              }
            })
            .catch((error) => {
              dispatch(fetchTemplateEditDataFailure(error));
            });
        } else {
          throw new Error(resp.data.ResponseStatus);
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
      })
      .finally(() => {
        dispatch(redirectToTemplateManagement());
      });
  };
};

export const activateTemplate = (templateId) => {
  return async (dispatch, getState) => {
    const contextId = selectContextId(getState()).toString();
    dispatch(activateTemplateBegin());
    patchActivateTemplate(contextId, templateId)
      .then((resp) => {
        const success =
          resp &&
          resp.data &&
          resp.data.ResponseStatus &&
          resp.data.ResponseStatus.Message === 'Success';
        if (success) {
          const templateId = resp.data.TemplateId;
          dispatch(fetchTemplateEditDataBegin());
          return getTemplate(contextId, templateId)
            .then((response) => {
              const success =
                response.data.ResponseStatus.Message === 'Success';
              if (success) {
                const found = cloneDeep(response.data.Templates[0]);
                const templateData = camelcaseKeysDeep(found);
                dispatch(fetchTemplateEditDataSuccess(templateData));
              } else {
                dispatch(fetchTemplateEditDataFailure());
              }
            })
            .catch((error) => {
              dispatch(fetchTemplateEditDataFailure(error));
            });
        } else {
          throw new Error(resp.data.ResponseStatus);
        }
      })
      .catch((err) => {
        dispatch(showNotification(err.message, 'error'));
      })
      .finally(() => {
        dispatch(loadTemplates());
      });
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {
  [SET_LD_FLAG]: (state, action) => {
    return {
      ...state,
      autopopflag: { value: action.value, isLoaded: action.isLoaded },
      autopopflagLoading: false,
    };
  },
  [SELECTED_EVENT_TYPE_FROM_DROPDOWN]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      eventCategory: action.eventCategory,
      touched: true,
    });
    return newState;
  },
  [SELECTED_SEASON_TYPE_FROM_DROPDOWN]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      seasonCategory: action.seasonCategory,
      touched: true,
    });
    return newState;
  },
  [REMOVE_SELECTED_OFFER]: (state, action) => {
    const newState = {};
    const allZones = cloneDeep(state.linkedZones);
    let saveTouchedZone;
    const linkedZones = allZones.map((zone) => {
      const offers = zone.offers.filter((offer) => {
        if (offer.id === action.offer.id) {
          saveTouchedZone = zone;
        } else return true;
      });
      return saveTouchedZone && saveTouchedZone.id === zone.id
        ? Object.assign({}, zone, {
            offers,
            deletedLocally: zone.deletedLocally
              ? [
                  ...zone.deletedLocally,
                  mergeTwoObject(saveTouchedZone, action.offer),
                ]
              : [mergeTwoObject(saveTouchedZone, action.offer)],
          })
        : Object.assign({}, zone, { offers });
    });
    Object.assign(newState, state, {
      linkedZones,
      touched: true,
      fetchedRemaining: false,
    });
    Object.assign(newState, state, {
      linkedZones,
      touched: true,
      fetchedRemaining: false,
    });
    return newState;
  },
  [CHANGE_OFFER_PUBLIC_MODE]: (state, action) => {
    const newState = {};
    const allZones = cloneDeep(state.linkedZones);
    const linkedZones = allZones.map((zone) => {
      const offers =
        zone.offers &&
        zone.offers.map((offer) => {
          if (offer.id === action.offer.id) {
            offer.isAutoPublish = action.offer.isAutoPublish;
          }
          return offer;
        });
      return Object.assign({}, zone, { offers });
    });
    Object.assign(newState, state, { linkedZones, touched: true });
    return newState;
  },
  [CHANGE_OFFER_PUBLIC_MODE]: (state, action) => {
    const newState = {};
    const allZones = cloneDeep(state.linkedZones);
    const linkedZones = allZones.map((zone) => {
      const offers =
        zone.offers &&
        zone.offers.map((offer) => {
          if (offer.id === action.offer.id) {
            offer.isAutoPublish = action.offer.isAutoPublish;
          }
          return offer;
        });
      return Object.assign({}, zone, { offers });
    });
    Object.assign(newState, state, { linkedZones, touched: true });
    return newState;
  },
  [REMOVED_SELECTED_ZONE]: (state, action) => {
    const newState = {};
    const linkedZonesCopy = cloneDeep(state.linkedZones);
    const linkedZones = linkedZonesCopy.filter(
      (zone) => zone.id !== action.zone.id
    );
    Object.assign(newState, state, { linkedZones, touched: true });
    return newState;
  },
  [CANCEL_TEMPLATE_CREATION]: (state) => {
    const newState = {};
    Object.assign(newState, state, initialState);
    return newState;
  },
  [FETCH_SPECIFIC_EVENT_DATA_SUCCESS]: (state, action) => {
    //called when an event is selected to create new template
    const newState = {};
    const allZones = action.event.zones.map((zone) => zone);

    const unsupportedOffers = [];
    const unsupportedFlashOffers = [];
    const venueIsLinkedToFlash =
      action.event.flashTimeZoneId &&
      action.event.flashTimeZoneId != 0 &&
      action.event.flashEventOwnerId &&
      action.event.flashEventOwnerId != 0 &&
      action.event.flashVenueId &&
      action.event.flashVenueId != 0;
    //filter the unsupported offers out of the zones
    //and into their own lists
    const linkedZones = allZones.map((zone) => {
      const zoneObj = Object.assign({}, zone);
      const zoneOffers = [];
      zone.offers.forEach((offer) => {
        const offerObj = Object.assign({}, offer);
        const hasFlashMOD = offerObj.deliveryMethods.some(
          (deliveryMethod) =>
            Number(deliveryMethod.process) ===
            Number(ticketProcessTypes.FLASH_SEATS)
        );
        if (offer.offerType !== 'Single') {
          unsupportedOffers.push(offerObj);
        } else if (!venueIsLinkedToFlash && hasFlashMOD) {
          unsupportedFlashOffers.push(offerObj);
        } else {
          zoneOffers.push(offerObj);
        }
      });
      return Object.assign({}, zoneObj, { offers: zoneOffers });
    });

    Object.assign(
      newState,
      state,
      { unsupportedOffers },
      { unsupportedFlashOffers },
      { linkedZones },
      { venue: action.event.venue },
      { venueId: action.event.venueId },
      { eventType: action.event.eventType },
      { eventName: action.event.eventName },
      { startDate: action.event.startDate },
      { timeZone: action.event.timeZone },
      {
        eventCategory: action.template
          ? formatEventsCategory(action.template.categories)
          : [],
      },
      {
        seasonCategory: action.template
          ? formatSeasonsCategory(action.template.categories)
          : [],
      },
      { eventId: action.event.id },
      { templateName: '' },
      { isLoading: false },
      { venueIsLinkedToFlash }
    );
    return newState;
  },
  [FETCH_SPECIFIC_EVENT_DATA_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [FETCH_TEMPLATE_EDIT_DATA_SUCCESS]: (state, action) => {
    const newState = {};
    const linkedZones = action.template.zones.map((zone) => zone);
    Object.assign(
      newState,
      state,
      { linkedZones },
      { venue: action.template.venueName },
      { eventTypes: action.template.categories },
      { originalTemplateName: action.template.name },
      { templateName: action.template.name },
      { templateId: action.template.id },
      { eventCategory: formatEventsCategory(action.template.categories) },
      { seasonCategory: formatSeasonsCategory(action.template.categories) },
      { eventId: action.template.eventId },
      { eventName: action.template.eventName },
      { isActive: action.template.isActive },
      { fetchedRemaining: false }
    );
    return newState;
  },
  [FETCH_TEMPLATE_EDIT_DATA_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [SUBMIT_CREATE_TEMPLATE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { sendingTemplateData: true });
    return newState;
  },
  [SUBMIT_CREATE_TEMPLATE_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      initialState,
      { networkMessage: action.successMessage },
      { lastTouchedTemplate: action.templateId },
      { lastTouchedTemplateState: 'NEW' }
    );
    return newState;
  },
  [SUBMIT_CREATE_TEMPLATE_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { networkMessage: action.failureMessage },
      { sendingTemplateData: false }
    );
    return newState;
  },
  [SUBMIT_EDIT_TEMPLATE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [SUBMIT_EDIT_TEMPLATE_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(
      newState,
      initialState,
      { networkMessage: action.successMessage },
      { lastTouchedTemplate: action.templateId },
      { lastTouchedTemplateState: 'EDITED' }
    );
    return newState;
  },
  [SUBMIT_EDIT_TEMPLATE_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { networkMessage: action.failureMessage });
    return newState;
  },
  [HANDLE_TEMPLATE_NAME_INPUT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      templateName: action.text,
      touched: true,
    });
    return newState;
  },
  [REDIRECT_TO_TEMPLATE_MANAGEMENT]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DELETE_TEMPLATE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DELETE_TEMPLATE_FAILURE]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [DELETE_TEMPLATE_SUCCESS]: () => {
    const newState = {};
    Object.assign(newState, initialState);
    return newState;
  },
  [GET_EVENT_CATEGORIES_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_EVENT_CATEGORIES_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { failureMessage: action.failureMessage });
    return newState;
  },
  [DEACTIVATE_TEMPLATE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { shouldFetchData: true });
    return newState;
  },
  [ACTIVATE_TEMPLATE_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_EVENT_CATEGORIES_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      allEventCategories: formatEventsCategory(action.eventCategories),
    });
    return newState;
  },
  [GET_SEASON_CATEGORIES_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_SEASON_CATEGORIES_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { failureMessage: action.failureMessage });
    return newState;
  },
  [GET_SEASON_CATEGORIES_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      allSeasonCategories: formatSeasonsCategory(action.seasonCategories),
    });
    return newState;
  },
  [DIRECT_TO_EDIT_TEMPLATE_OFFER]: (state) => {
    const newState = {};
    Object.assign(newState, state, { shouldFetchData: false });
    return newState;
  },
  [DIRECT_TO_CREATE_TEMPLATE_EDIT_OFFER]: (state) => {
    const newState = {};
    Object.assign(newState, state, { shouldFetchData: false });
    return newState;
  },
  [DIRECT_TO_EDIT_TEMPLATE]: (state) => {
    const newState = {};
    Object.assign(newState, state, { allPromoTemplates: [] });
    return newState;
  },
  [FETCH_TEMPLATE_BASE_EVENT_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { isLoading: true });
    return newState;
  },
  [FETCH_TEMPLATE_BASE_EVENT_SUCCESS]: (state, action) => {
    //called when editing an existing template

    //create lists of unsupported offers, but do not filter them out of the zones
    //since they are already saved on the template
    const unsupportedOffers = [];
    const unsupportedFlashOffers = [];
    const venueIsLinkedToFlash =
      action.event &&
      action.event.flashTimeZoneId &&
      action.event.flashEventOwnerId &&
      action.event.flashVenueId;

    //add descriptions and delivery methods from the event zones,
    //since this data may not be in the template
    const linkedZones = state.linkedZones.map((zone) => {
      const zoneObj = Object.assign({}, zone);
      const zoneOffers = [];
      const detailedZone = action.event.zones.find(
        (eventZone) => Number(eventZone.id) === Number(zone.id)
      );
      if (detailedZone) zoneObj.description = detailedZone.description;

      zone.offers.forEach((offer) => {
        //add the detailed zone info to the offer
        const detailedOffer = detailedZone
          ? detailedZone.offers.find(
              (eventOffer) => Number(eventOffer.id) === Number(offer.id)
            )
          : {};
        const deliveryMethods = detailedOffer
          ? detailedOffer.deliveryMethods
          : [];
        const offerObj = Object.assign({}, offer, {
          deliveryMethods: deliveryMethods,
        });
        zoneOffers.push(offerObj);
        //format axs promotion fields
        let axsPromotion = {};
        let offerSavedWithSeparatePromo = false;
        if (offerObj.hasOwnProperty('aXSPromotion')) {
          axsPromotion = { ...offerObj.aXSPromotion };
          delete offerObj.aXSPromotion;
          axsPromotion = receiveOfferPromotion(offerObj, 'template');
          offerSavedWithSeparatePromo =
            offerObj.axsPromotion &&
            Number(offerObj.axsPromotion.ticketLinkType) ===
              Number(ticketLinkTypes.SEPARATE_PROMOTION);
        }
        offerObj.axsPromotion = axsPromotion;
        offerObj.offerSavedWithSeparatePromo = offerSavedWithSeparatePromo;
        //put unsupported offers into lists but do not remove them from the zone
        const hasFlashMOD = offerObj.deliveryMethods.some(
          (deliveryMethod) =>
            Number(deliveryMethod.process) ===
            Number(ticketProcessTypes.FLASH_SEATS)
        );
        if (offerObj.offerType !== 'Single') {
          unsupportedOffers.push(offerObj);
        } else if (!venueIsLinkedToFlash && hasFlashMOD) {
          unsupportedFlashOffers.push(offerObj);
        }
      });
      return Object.assign({}, zoneObj, { offers: zoneOffers });
    });
    const newState = {};
    Object.assign(
      newState,
      state,
      { linkedZones },
      { unsupportedOffers },
      { unsupportedFlashOffers },
      { venueIsLinkedToFlash },
      { baseEvent: action.event },
      { isLoading: false }
    );
    return newState;
  },
  [UPDATE_TEMPLATE_OFFER_CMS]: (state, action) => {
    const axsPromotion = {
      ticketLinkType: action.data && action.data.ticketLink,
    };
    if (
      Number(axsPromotion.ticketLinkType) ===
      Number(ticketLinkTypes.SEPARATE_PROMOTION)
    ) {
      axsPromotion.promoName = action.data.promoName;
      axsPromotion.promoDescription = action.data.promoDescription;
      axsPromotion.promoShortDescription = action.data.promoShortDescription;
      axsPromotion.promoGroup = action.data.promoGroup;
      axsPromotion.promoTemplate = action.data.promoTemplate;
      axsPromotion.visibleStartDate = action.data.dates.visibleStartDate;
      axsPromotion.visibleEndDate = action.data.dates.visibleEndDate;
      axsPromotion.status = action.data.status;
      axsPromotion.display = action.data.display;
    }
    const allZones = state.linkedZones.map((zone) => zone);
    const linkedZones = allZones.map((zone) => {
      const zoneOffers = zone.offers.map((offer) => {
        if (Number(offer.id) === Number(action.offerId)) {
          return Object.assign({}, offer, { axsPromotion });
        }
        return offer;
      });
      return Object.assign({}, zone, { offers: zoneOffers });
    });
    const newState = {};
    Object.assign(newState, state, { linkedZones });
    return newState;
  },
  [GET_PROMO_GROUPS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [GET_PROMO_GROUPS_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { error: action.err });
    return newState;
  },
  [GET_PROMO_GROUPS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { allPromoGroups: action.promoGroups });
    return newState;
  },
  [GET_PROMO_TEMPLATES_SUCCESS]: (state, action) => {
    const newState = {};
    const allPromoTemplates = action.promoTemplates.map((template) => {
      const defaultTemplate = template.promoTemplateDefault;
      return Object.assign(
        {},
        { id: Number(template.id) },
        { name: defaultTemplate.defaultName },
        { promoName: defaultTemplate.defaultTemplateName },
        { promoShortDescription: defaultTemplate.defaultShortDescription },
        { promoDescription: defaultTemplate.defaultDescription }
      );
    });
    Object.assign(newState, state, { allPromoTemplates });
    return newState;
  },
  [GET_REMAINING_OFFERS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state, { remainingOffersIsLoading: true });
    return newState;
  },
  [GET_REMAINING_OFFERS_SUCCESS]: (state, action) => {
    const newState = {};
    // const linkedZones = action.template.zones.map((zone) => zone);
    const linkedZones = action.template.linkedZones;
    const remainingZones = action.zones;
    remainingZones.forEach((rem) => {
      let indexOfZone = indexOfObjects(linkedZones, rem.id);
      if (indexOfZone !== -1) {
        let linkedOffers = linkedZones[indexOfZone].offers;
        linkedZones[indexOfZone].offers = linkedOffers.concat(
          filterOnlyNews(linkedOffers, rem.offers)
        );
      } else {
        linkedZones.push(rem);
      }
    });

    Object.assign(
      newState,
      state,
      { linkedZones },
      { remainingOffersIsLoading: false, fetchedRemaining: true }
    );
    return newState;
  },
  [GET_REMAINING_OFFERS_FAILURE]: (state, action) => {
    return {
      ...state,
      remainingOffersIsLoading: false,
      fetchedRemaining:
        action.err === RemainingOffersErrors.NO_MORE_ERROR ? true : false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
//
//

export const initialState = {
  allEventCategories: [],
  allSeasonCategories: [],
  allPromoGroups: [],
  allPromoTemplates: [],
  baseEvent: {},
  error: '',
  eventCategory: [],
  seasonCategory: [],
  eventId: '',
  eventName: '',
  eventTypes: {},
  isLoading: false,
  lastTouchedTemplate: '',
  lastTouchedTemplateState: '',
  linkedZones: [],
  networkMessage: '',
  originalTemplateName: '',
  sendingTemplateData: false,
  shouldFetchData: true,
  startDate: '',
  templateId: '',
  templateName: '',
  timeZone: '',
  touched: false,
  unsupportedOffers: [],
  unsupportedFlashOffers: [],
  venue: '',
  remainingOffersIsLoading: false,
  fetchedRemaining: false,
  venueIsLinkedToFlash: false,
  autopopflag: {},
  autopopflagLoading: true,
};

export default function templateFormReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/Templates/common/modules/templateForm.js